/* eslint-disable react/prop-types */
import {
  Box, CardContent, Grid,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Skeleton } from '@material-ui/lab';

const useStyles = makeStyles((theme) => ({
  cardContent: {
    background: theme.palette.background.card,
    borderRadius: '16px',
  },
  boxContent: {
    padding: theme.spacing(3, 2),
  },
  container: {
    padding: theme.spacing(1, 2),
    borderRadius: '8px',
    marginLeft: theme.spacing(2),
  },
}));

function SkeletonAllNotes() {
  const classes = useStyles();

  return (
    <Grid
      container
      direction="row"
      justifyContent="space-between"
      alignItems="stretch"
    >
      <Grid item xs={10}>
        <Box className={classes.boxContent}>
          <Box className={classes.cardContent}>
            <CardContent className={classes.boxContent}>
              <Skeleton variant="rectangular" width={1070} height={18} />
            </CardContent>
          </Box>
        </Box>
      </Grid>
      <Grid item xs={2}>
        <CardContent className={classes.boxContent}>
          <Box className={classes.boxContentEdit}>
            <Skeleton variant="rectangular" width={60} height={60} />
          </Box>
        </CardContent>
      </Grid>
      <Grid item xs={10}>
        <Box className={classes.boxContent}>
          <Box className={classes.cardContent}>
            <CardContent className={classes.boxContent}>
              <Skeleton variant="rectangular" width={1070} height={18} />
            </CardContent>
          </Box>
        </Box>
      </Grid>
      <Grid item xs={2}>
        <CardContent className={classes.boxContent}>
          <Box className={classes.boxContentEdit}>
            <Skeleton variant="rectangular" width={60} height={60} />
          </Box>
        </CardContent>
      </Grid>
      <Grid item xs={10}>
        <Box className={classes.boxContent}>
          <Box className={classes.cardContent}>
            <CardContent className={classes.boxContent}>
              <Skeleton variant="rectangular" width={1070} height={18} />
            </CardContent>
          </Box>
        </Box>
      </Grid>
      <Grid item xs={2}>
        <CardContent className={classes.boxContent}>
          <Box className={classes.boxContentEdit}>
            <Skeleton variant="rectangular" width={60} height={60} />
          </Box>
        </CardContent>
      </Grid>
    </Grid>

  );
}

export default SkeletonAllNotes;
